import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    size: "large",
    class: "w-100",
    remote: true,
    filterable: true,
    clearable: true,
    onClear: _ctx.handleClear,
    placeholder: "Search job booker",
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
    onChange: _cache[1] || (_cache[1] = ev => _ctx.$emit('valueChange', ev)),
    "remote-method": _ctx.handleSearch,
    onVisibleChange: _ctx.handleVisibilityChange,
    loading: _ctx.loading
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          label: item.name,
          value: item.id,
          key: item.id
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["onClear", "modelValue", "remote-method", "onVisibleChange", "loading"]))
}